import { ref } from 'vue'
import type { ChatMessageCp } from '@/types/chatCp'

// Irmão WootDash-nativo de useMessageCache.ts (que continua servindo FocoView.vue/
// MobileView.vue sem mudança) — mesmo padrão de ref singleton em nível de módulo, só troca
// a chave de number (Chatwoot) pra string (Guid do WootDash).
const _msgCacheCp = ref<Record<string, ChatMessageCp[]>>({})

export function useMessageCacheCp() {
  return { msgCache: _msgCacheCp }
}

export function resetMessageCacheCp(): void {
  _msgCacheCp.value = {}
}
